/**
 * User Hook
 *
 * Provides access to the current user's profile and preferences.
 * Shared between web and mobile apps.
 */

import { useQuery, useMutation } from 'convex/react';
import { api } from '@have-done/backend/convex/_generated/api';

/**
 * Get the current user's profile
 * Returns null if not authenticated or user doesn't exist yet
 */
export function useUser() {
  return useQuery(api.users.me);
}

/**
 * Update user preferences (theme, default category)
 */
export function useUpdatePreferences() {
  return useMutation(api.users.updatePreferences);
}

/**
 * Update user profile (name)
 */
export function useUpdateProfile() {
  return useMutation(api.users.updateProfile);
}

/**
 * Update user email preferences (weekly summary, streak milestones, etc.)
 */
export function useUpdateEmailPreferences() {
  return useMutation(api.users.updateEmailPreferences);
}

/**
 * Delete user account and all data
 */
export function useDeleteAccount() {
  return useMutation(api.users.deleteAccount);
}
